import React, { useState, useRef } from 'react'
import logo from '../icici-bank.png';
import './documentUpload.css'; // Import the CSS file
import upload from "../asset/upload.png"
import aadhaar from "../asset/aadhaar.png"
import license from "../asset/license.png"
import passport from "../asset/passport.png"
import MGNREGA from "../asset/file.png"
import voterId from "../asset/business-card.png"
import LoaderShemer from "../asset/Animation1741239213486.gif"
import { MdDeleteForever } from "react-icons/md";
import { ShimmerTitle } from "react-shimmer-effects";
import Snackbar from '../UIComponent/snackbar';
import { FaUpload, FaTimesCircle } from 'react-icons/fa';
import CryptoService from './CyrptoService';


export const DocumentUpload = ({ setFlowDoc, setDocumentImage, setvalidDocument, refId }) => {
    const [alertMessage, setAlertMessage] = useState(false);
    const [docType, setDocType] = useState('Aadhaar')

    return (
        <>
            <Snackbar message="Please upload valid document" type="info" duration='5000' alertMessage={alertMessage} setAlertMessage={setAlertMessage} />
            <div className="video-recorder-container" >
                {/* Main container */}
                <div className="video-recorder-main" style={{ background: 'linear-gradient(0deg, rgba(255,219,169,1) 3%, rgba(255,236,209,1) 50%, rgba(255,240,219,1) 70%)' }} >
                    <div className="video-recorder-top-bar" >
                        <img src={logo} className="App-logo" alt="logo" style={{ padding: 3, width: '150px' }} />
                    </div>
                    {/* slider */}
                    <div style={{ width: "100%", position: "relative", marginTop: '4px' }}>
                        <div
                            style={{
                                height: "1.5px",
                                width: "100%",
                                background: "#ccc",
                                borderRadius: "2px",
                                position: "relative",
                            }}
                        >
                            <div
                                style={{
                                    height: "1.5px",
                                    width: "25%",
                                    background: "#007bff",
                                    borderRadius: "2px",
                                    position: "absolute",
                                }}
                            >

                            </div>
                            <div
                                style={{
                                    height: "8px",
                                    width: "8px",
                                    background: "#007bff",
                                    borderRadius: "50%",
                                    position: "absolute",
                                    left: "25%",
                                    top: "50%",
                                    transform: "translate(-50%, -50%)",
                                }}
                            ></div>
                        </div>
                    </div>
                    <h2 className="video-recorder-heading" style={{ color: '#464f82' }}>OVD Document Verification</h2>
                    <div className="video-recorder-video-container" >
                        <div style={{ margin: 'auto', padding: '10px', background: '#F8F9FA', borderRadius: '6px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', height: '100%' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <h2 style={{ fontSize: '14px', fontWeight: '600', color: '#003366', }}>UPLOAD OVD DOCUMENT</h2>
                                <select style={{ width: '30%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc', marginBottom: '10px' }} onChange={(e) => setDocType(e.target.value)} value={docType}>

                                    <option value="Aadhaar">Aadhaar</option>
                                    <option value="Driving License">Driving License</option>
                                    <option value="Passport">Passport</option>
                                    <option value="MGNREGA">MGNREGA</option>
                                    <option value="Voter ID">Voter ID</option>
                                </select>
                            </div>
                            {
                                docType === 'Aadhaar' ?
                                    <AadhaarUploader setFlowDoc={setFlowDoc} setDocumentImage={setDocumentImage} setvalidDocument={setvalidDocument} refId={refId} docType={docType} />
                                    :
                                    <DocCompoment setFlowDoc={setFlowDoc} setDocumentImage={setDocumentImage} setvalidDocument={setvalidDocument} refId={refId} docType={docType} />
                            }
                        </div>

                    </div>
                </div>

                <style>
                    {`
                        @keyframes blink {
                            0% { opacity: 1; }
                            50% { opacity: 0.2; }
                            100% { opacity: 1; }
                        }
                    `}
                </style>
            </div>
        </>
    )
}


const DocCompoment = ({ setFlowDoc, setDocumentImage, setvalidDocument, refId, docType }) => {
    const [loading, setLoading] = useState(false)
    const [file, setFile] = useState('');
    const [previewImage, setPreviewImage] = useState(null);
    const [fetchedData, setFetchedData] = useState([])
    const [proced, setProced] = useState(false)
    const [base64DocImage, setbase64DocImage] = useState('')
    const [alertMessage, setAlertMessage] = useState(false);
    const [fileExtensiontype, setFileExtensiontype] = useState('')
    const [base64File, setBase64File] = useState('')
    // const [docType, setDocType] = useState('')

    const handleFileSubmit = async (e) => {
        const selectedFile = e.target.files[0];
        const fileName = selectedFile?.name;
        const fileExtension = fileName?.split('.').pop().toLowerCase();
        setFileExtensiontype(fileExtension)

        if (selectedFile) {
            try {
                // Compress the image
                // const compressedImage = await compressImage(selectedFile);
                // Convert the compressed image to Base64
                const reader = new FileReader();
                reader.onloadend = () => {
                    const base64String = reader.result.split(",")[1]; // Extract the Base64 string
                    // console.log('base64String', base64String);
                    setDocumentImage(base64String)
                    setBase64File(base64String)
                    // setFile("b " + base64String)
                    setFile(`b'${base64String}'`)
                    setPreviewImage(reader.result);
                };
                reader.readAsDataURL(selectedFile); // Read the compressed image as a data URL

                // Store the compressed image as a Blob
                setFile(selectedFile);
            } catch (error) {
                console.error("Error compressing image:", error);
                alert("Failed to compress the image. Please try again.");
            }
        }
    }

    const compressImage = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);

            reader.onload = (event) => {
                const img = new Image();
                img.src = event.target.result;

                img.onload = () => {
                    const canvas = document.createElement("canvas");
                    const ctx = canvas.getContext("2d");

                    // Set the desired width and height for compression
                    const maxWidth = 800; // Maximum width
                    const maxHeight = 800; // Maximum height
                    let width = img.width;
                    let height = img.height;

                    // Maintain aspect ratio
                    if (width > height) {
                        if (width > maxWidth) {
                            height = Math.round((height * maxWidth) / width);
                            width = maxWidth;
                        }
                    } else {
                        if (height > maxHeight) {
                            width = Math.round((width * maxHeight) / height);
                            height = maxHeight;
                        }
                    }

                    canvas.width = width;
                    canvas.height = height;

                    // Draw the image on the canvas
                    ctx.drawImage(img, 0, 0, width, height);

                    // Convert the canvas to a Blob
                    canvas.toBlob(
                        (blob) => {
                            if (blob) {
                                resolve(blob); // Return the compressed image as a Blob
                            } else {
                                reject(new Error("Image compression failed"));
                            }
                        },
                        "image/jpeg", // Output format
                        0.7 // Quality (0.1 to 1.0, lower means more compression)
                    );
                };

                img.onerror = (error) => reject(error);
            };

            reader.onerror = (error) => reject(error);
        });
    };

    const handleVerify = async () => {
        setLoading(true)

        try {
            // const data = new FormData();
            // data.append("ImageByte", file);
            // console.log('file', file);


            // const config = {
            //     method: "POST",
            //     headers: {
            //         "x-api-key": "VW2AOqQUif2YWNn0rfEcf2qOMA8Nohbt9qsqv15t",
            //         authorizationToken: "H472huRsa15JptU3",
            //     },
            //     body: data,
            // };

            // await fetch("https://gbgu3al7u9.execute-api.ap-south-1.amazonaws.com/default/ovd_identification", config)
            //     .then((response) => {
            //         if (!response.ok) {
            //             throw new Error("Something went wrong with the server");
            //         }
            //         return response.json();
            //     })
            //     .then((responseData) => {
            //         if (responseData.documenttype == 1) {
            //             setvalidDocument(true)
            //             // console.log(responseData);
            //             setFetchedData({
            //                 Name: responseData["item.details.name.value"],
            //                 Addhar_No: responseData["item.details.aadhaar.value"],
            //                 dob: responseData["item.details.dob"],
            //                 Gender: responseData["item.details.gender.value"],
            //                 // docImageFaceVerification: responseData["item.details.aadhaar.masked_value"],
            //             })
            //             // data:image/jpeg;base64,
            //             setPreviewImage(`data:image/jpeg;base64,${responseData["item.details.aadhaar.masked_value"]}`)
            //             setProced(true)
            //         }
            //         else if (responseData.documenttype == 2) {
            //             setvalidDocument(true)
            //             // console.log(responseData);
            //             setFetchedData({
            //                 Name: responseData.name,
            //                 Surname: responseData.surname,
            //                 Doc_Number: responseData.docnumber,
            //                 Country: responseData.country,
            //                 DOB: responseData.dob,
            //                 Gender: responseData.gender,
            //                 Expiry: responseData.expirydate,
            //             })

            //             setProced(true)
            //         } else if (responseData.documenttype == 3) {
            //             setvalidDocument(true)
            //             // console.log(responseData);
            //             setFetchedData({
            //                 Name: responseData.name,
            //                 License_No: responseData.drivinglicenseno,
            //                 Date_Of_Issue: responseData.dateofissue,
            //                 Validity: responseData.validitynt,
            //             })

            //             setProced(true)
            //         } else if (responseData.documenttype == 4) {
            //             setvalidDocument(true)
            //             // console.log(responseData);
            //             setFetchedData({
            //                 Name: responseData.name,
            //                 Voter_Id: responseData.voterid,
            //                 Parent_Name: responseData.guardianname,
            //                 DOB: responseData.dob,
            //                 Gender: responseData.gender,
            //                 Address: responseData.Address,
            //             })

            //             setProced(true)
            //         } else {
            //             setAlertMessage(true)
            //             const timer = setTimeout(() => {
            //                 setAlertMessage(false);
            //             }, 5000);
            //             setLoading(false)
            //             return () => clearTimeout(timer);
            //         }
            //         setLoading(false);
            //     })
            //     .catch((error) => {
            //         setLoading(false)
            //         alert("Something went wrong with server");
            //         console.error(error);
            //     });


            let obj = {
                base64_image: file,
                doc_type: docType,
                file_type: fileExtensiontype,
                request_id: refId
            }

            console.log('handleVerify obj:', obj);

            // Encrypt
            const encrypted = CryptoService.encrypt(obj);
            console.log("encrypted", encrypted);

            const formdata = new FormData();
            formdata.append("source_id", "1");
            formdata.append("data", encrypted);

            const requestOptions = {
                method: "POST",
                body: formdata,
                redirect: "follow"
            };

            fetch("https://z33q3r9qqd.execute-api.ap-south-1.amazonaws.com/default/new_ovd", requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    console.log(result);
                    // Decrypt
                    // const decrypted = CryptoService.decrypt(result.data);
                    // console.log('Decrypted:', JSON.parse(decrypted));
                    if (result.documenttype == 0) {
                        alert('Invalid document')
                        setLoading(false)
                    }
                    else if (result.documenttype == 1) {
                        setvalidDocument(true)
                        // console.log(responseData);
                        setFetchedData({
                            Name: result["item.details.name.value"],
                            Addhar_No: result["item.details.aadhaar.value"],
                            dob: result["item.details.dob"],
                            Gender: result["item.details.gender.value"],
                            // docImageFaceVerification: result["item.details.aadhaar.masked_value"],
                        })
                        // data:image/jpeg;base64,
                        setPreviewImage(`data:image/jpeg;base64,${result["item.details.aadhaar.masked_value"]}`)
                        setProced(true)
                        setLoading(false)
                    } else if (result.documenttype == 2) {
                        setvalidDocument(true)
                        // console.log(responseData);
                        setFetchedData({
                            Name: result.name,
                            Surname: result.surname,
                            Doc_Number: result.docnumber,
                            Country: result.country,
                            DOB: result.dob,
                            Gender: result.gender,
                            Expiry: result.expirydate,
                        })

                        setProced(true)
                        setLoading(false)
                    } else if (result.documenttype == 3) {
                        setvalidDocument(true)
                        // console.log(responseData);
                        setFetchedData({
                            Name: result.name,
                            License_No: result.drivinglicenseno,
                            Date_Of_Issue: result.dateofissue,
                            Validity: result.validitynt,
                        })

                        setProced(true)
                        setLoading(false)
                    } else if (result.documenttype == 4) {
                        setvalidDocument(true)
                        // console.log(responseData);
                        setFetchedData({
                            Name: result.name,
                            Voter_Id: result.voterid,
                            Parent_Name: result.guardianname,
                            DOB: result.dob,
                            Gender: result.gender,
                            Address: result.Address,
                        })

                        setProced(true)
                        setLoading(false)
                    } else {
                        setAlertMessage(true)
                        const timer = setTimeout(() => {
                            setAlertMessage(false);
                        }, 5000);
                        setLoading(false)
                        return () => clearTimeout(timer);
                    }

                })
                .catch((error) => console.error(error));

        } catch (error) {
            setLoading(false);
            console.error("Error compressing image:", error);
        }

    }

    const handleProcced = () => {
        setLoading(true)
        function lmbd_ovd_step_status() {
            let obj = { request_id: refId, is_document_uploaded: true, is_ipv_done: false, is_face_match_done: false }

            // Encrypt
            const encrypted = CryptoService.encrypt(obj);
            console.log("encrypted", encrypted);

            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            const raw = JSON.stringify({
                "data": encrypted,
                "source_id": "1"
            });

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };

            fetch("https://z33q3r9qqd.execute-api.ap-south-1.amazonaws.com/default/step_status", requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    console.log(result);
                    // Decrypt
                    const decrypted = CryptoService.decrypt(result.data);
                    console.log('lmbd_ovd_step_status:', JSON.parse(decrypted));
                    // step_status()
                    UploadDoc()
                })
                .catch((error) => console.error(error));

        }
        lmbd_ovd_step_status()

        function UploadDoc() {
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            const raw = JSON.stringify({
                "source_id": "1",
                "reqid": refId,
                "doctype": "ADDHAAR",
                "base64": base64File,
                "filetype": "png",
                "ovdresponse": "successfully uploaded"
            });

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };

            fetch("https://uos01m6pv3.execute-api.ap-south-1.amazonaws.com/default/lmbd_ovd_document_upload", requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    console.log(result)
                    setFlowDoc('VedioRecorder')
                    // step_status()
                    setLoading(false)
                })
                .catch((error) => {
                    console.error(error)
                    setLoading(false)
                });
        }

    }

    const handleClear = () => {
        setFile('')
        setPreviewImage(null)
        setFetchedData([])
        setProced(false)
    }

    return <>
        <div >
            <div
                style={{
                    height: '6rem',
                    border: '1px solid #ccc',
                    borderRadius: '6px',
                    margin: '10px',
                    padding: '10px',
                    background: '#fff',
                    cursor: 'pointer', // Add pointer cursor to indicate clickability
                    textAlign: 'center'
                }}
                onClick={() => document.getElementById('fileInput').click()} // Trigger file input click
            >
                {previewImage ? (
                    <>
                        <div style={{ height: '100%', position: 'relative' }}>
                            <img
                                src={previewImage}
                                alt="Uploaded Preview"
                                style={{
                                    width: "33%",
                                    height: "100%",
                                    objectFit: "contain",
                                    // marginBottom: "10px",
                                }}
                            />
                            <div style={{ position: 'absolute', top: 0 }}
                                onMouseEnter={(e) => e.currentTarget.firstChild.style.color = 'red'}
                                onMouseLeave={(e) => e.currentTarget.firstChild.style.color = 'rgba(253, 19, 19, 0.72)'}
                                onClick={handleClear}
                            >
                                <MdDeleteForever style={{ color: 'rgba(253, 19, 19, 0.72)', width: '30px', height: '30px' }} />
                            </div>
                        </div>
                    </>
                ) : (
                    <>
                        <div>
                            <img
                                src={upload}
                                alt="Upload Icon"
                                style={{ width: "40px", marginBottom: "1px" }}
                            />
                            <p
                                style={{
                                    fontSize: "12px",
                                    color: "#333",
                                    fontWeight: "600",
                                }}
                            >
                                Select your file
                            </p>
                            <p
                                style={{
                                    fontSize: "10px",
                                    color: "#666",

                                }}
                            >
                                Upload file in JPG, JPEG, or PDF format
                            </p>
                        </div>
                    </>
                )}
            </div>

            {Object.keys(fetchedData).length == 0 ?
                <>
                    {
                        loading ? <><ShimmerTitle line={5} gap={10} variant="secondary" /></> : <>  <p style={{ fontSize: '12px', fontWeight: '600', color: '#333', margin: '20px 0', textAlign: 'center' }}>Upload any of the listed documents for OVD</p>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr ', gap: '10px', textAlign: 'left', fontSize: '12px', color: '#333' }}>
                                <div style={{ display: 'flex' }}>  <img src={aadhaar} alt="Aadhaar Card" style={{ width: '40px', marginBottom: '10px', marginLeft: '10px', marginRight: '10px' }} /><p> Aadhaar Card</p></div>
                                <div style={{ display: 'flex' }}>  <img src={license} alt="Driving License" style={{ width: '40px', marginBottom: '10px', marginLeft: '10px', marginRight: '10px' }} /><p>  Driving License</p></div>
                                <div style={{ display: 'flex' }}>  <img src={passport} alt="Upload Icon" style={{ width: '40px', marginBottom: '10px', marginLeft: '10px', marginRight: '10px' }} /><p>Passport</p></div>
                                <div style={{ display: 'flex' }}>  <img src={MGNREGA} alt="Upload Icon" style={{ width: '40px', marginBottom: '10px', marginLeft: '10px', marginRight: '10px' }} /><p>MGNREGA</p></div>
                                <div style={{ display: 'flex' }}>  <img src={voterId} alt="Upload Icon" style={{ width: '40px', marginBottom: '10px', marginLeft: '10px', marginRight: '10px' }} /><p>Voter ID</p></div>
                            </div></>}
                </>
                :
                <>
                    {
                        Object.keys(fetchedData).length > 0 && (
                            <div style={{ marginTop: '20px', fontSize: '14px', color: '#333' }}>
                                {Object.entries(fetchedData).map(([key, value]) => (
                                    <p key={key} style={{ textAlign: 'left' }}>
                                        <strong>{key.replace(/_/g, ' ')}:</strong> {value ? value : 'N/A'}
                                    </p>
                                ))}
                            </div>
                        )}

                </>
            }

            {/* Hidden file input */}
            <input
                id="fileInput"
                type="file"
                accept="image/*,application/pdf" // Accept images and PDFs
                multiple
                style={{ display: 'none' }} // Hide the input element
                onChange={handleFileSubmit}
            />
        </div>
        {
            proced ?
                <button style={{ width: '80%', height: '40px', marginTop: '10px', padding: '8px', background: 'rgb(174, 1, 1)', border: 'none', borderRadius: '4px', color: 'white', fontSize: '16px', fontWeight: '600', cursor: "pointer", position: 'absolute', bottom: 2, transform: "translate(-50%)", left: "50%" }} onClick={handleProcced}>
                    {
                        loading ? <img style={{ width: '70px', marginTop: '-1.4rem' }} src={LoaderShemer} alt="My GIF" /> : ' Proceed'
                    }
                </button> :
                <button style={{ width: '80%', height: '40px', marginTop: '10px', padding: '8px', background: 'rgb(174, 1, 1)', border: 'none', borderRadius: '4px', color: 'white', fontSize: '16px', fontWeight: '600', cursor: "pointer", position: 'absolute', bottom: 2, transform: "translate(-50%)", left: "50%" }} onClick={handleVerify} disabled={!file || loading} >
                    {
                        loading ? <img style={{ width: '70px', marginTop: '-1.4rem' }} src={LoaderShemer} alt="My GIF" /> : 'Verify'
                    }
                </button>
        }
    </>
}

const AadhaarUploader = ({ setFlowDoc, setDocumentImage, setvalidDocument, refId, docType }) => {
    const [loading, setLoading] = useState(false)
    const [proced, setProced] = useState(false)
    const [file, setFile] = useState('');
    const [fetchedData, setFetchedData] = useState([])
    const [frontFile, setFrontFile] = useState(null);
    const [backFile, setBackFile] = useState(null);
    const [frontPreview, setFrontPreview] = useState('');
    const [alertMessage, setAlertMessage] = useState(false);
    const [backPreview, setBackPreview] = useState('');
    const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf'];
    const [fileExtensiontype, setFileExtensiontype] = useState('')
    const frontInputRef = useRef(null);
    const backInputRef = useRef(null);
    const [base64File, setBase64File] = useState('')

    const handleFileChange = (e, side) => {
        const file = e.target.files[0];
        const fileName = file?.name;
        const fileExtension = fileName?.split('.').pop().toLowerCase();
        setFileExtensiontype(fileExtension)

        if (!file) return;
        if (!allowedTypes.includes(file.type)) {
            alert('Only PDF or image files are allowed');
            return;
        }

        const reader = new FileReader();
        reader.onloadend = () => {
            const base64 = reader.result;
            if (side === 'front') {
                const base64String = reader.result.split(",")[1]; // Extract the Base64 string
                // console.log('base64String', base64String);
                setBase64File(base64String)
                setFrontFile(`b'${base64String}'`)
                setFrontPreview(base64);
            } else {
                const base64String = reader.result.split(",")[1]; // Extract the Base64 string
                setBackFile(`b'${base64String}'`)
                setBackPreview(base64);
            }
        };
        reader.readAsDataURL(file);
    };

    const handleRemove = (side) => {
        if (side === 'front') {
            setFrontFile(null);
            setFrontPreview('');
            frontInputRef.current.value = null; // 🛠️ Reset input
            // onUploadComplete?.({ frontBase64: '', backBase64: backPreview });
        } else {
            setBackFile(null);
            setBackPreview('');
            backInputRef.current.value = null; // 🛠️ Reset input
            // onUploadComplete?.({ frontBase64: frontPreview, backBase64: '' });
        }
    };

    const handleVerify = async () => {

        if (frontFile === null) {
            setLoading(false);
            alert("Please upload front side of Aadhaar card");
            return;
        }
        setDocumentImage(frontFile);
        try {
            if (backFile) {
                setLoading(true)
                try {

                    let obj = {
                        base64_image: backFile,
                        doc_type: "AADHAR_BACK1",
                        file_type: fileExtensiontype,
                        request_id: refId
                    }
                    console.log('handleVerify back obj:', obj);
                    // Encrypt
                    const encrypted = CryptoService.encrypt(obj);
                    // console.log("encrypted", encrypted);

                    const formdata = new FormData();
                    formdata.append("source_id", "1");
                    formdata.append("data", encrypted);

                    const requestOptions = {
                        method: "POST",
                        body: formdata,
                        redirect: "follow"
                    };

                    fetch("https://z33q3r9qqd.execute-api.ap-south-1.amazonaws.com/default/new_ovd", requestOptions)
                        .then((response) => response.json())
                        .then((result) => {
                            console.log(result);
                            // Decrypt
                            // const decrypted = CryptoService.decrypt(result.data);
                            // console.log('Decrypted:', JSON.parse(decrypted));
                            if (result.documenttype == 0) {
                                alert('Invalid document')
                                setLoading(false)
                            }
                            else if (result.documenttype == 1) {
                                setvalidDocument(true)
                                // console.log(responseData);
                                setFetchedData({
                                    Name: result["item.details.name.value"],
                                    Addhar_No: result["item.details.aadhaar.value"],
                                    dob: result["item.details.dob"],
                                    Gender: result["item.details.gender.value"],
                                    Address1: result["item.details.address.line1"],
                                    Address2: result["item.details.address.line2"],
                                    Pin: result["item.details.address.pin"],
                                    State: result["item.details.address.state"],
                                })
                                // data:image/jpeg;base64,
                                // setPreviewImage(`data:image/jpeg;base64,${result["item.details.aadhaar.masked_value"]}`)
                                setProced(true)
                                setLoading(false)
                            }
                            else if (result.documenttype == 2) {
                                setvalidDocument(true)
                                // console.log(responseData);
                                setFetchedData({
                                    Name: result.name,
                                    Surname: result.surname,
                                    Doc_Number: result.docnumber,
                                    Country: result.country,
                                    DOB: result.dob,
                                    Gender: result.gender,
                                    Expiry: result.expirydate,
                                })

                                setProced(true)
                                setLoading(false)
                            } else if (result.documenttype == 3) {
                                setvalidDocument(true)
                                // console.log(responseData);
                                setFetchedData({
                                    Name: result.name,
                                    License_No: result.drivinglicenseno,
                                    Date_Of_Issue: result.dateofissue,
                                    Validity: result.validitynt,
                                })

                                setProced(true)
                                setLoading(false)
                            } else if (result.documenttype == 4) {
                                setvalidDocument(true)
                                // console.log(responseData);
                                setFetchedData({
                                    Name: result.name,
                                    Voter_Id: result.voterid,
                                    Parent_Name: result.guardianname,
                                    DOB: result.dob,
                                    Gender: result.gender,
                                    Address: result.Address,
                                })

                                setProced(true)
                                setLoading(false)
                            } else {
                                // setAlertMessage(true)
                                const timer = setTimeout(() => {
                                    // setAlertMessage(false);
                                }, 5000);
                                setLoading(false)
                                return () => clearTimeout(timer);
                            }

                        })
                        .catch((error) => console.error(error));

                } catch (error) {
                    setLoading(false);
                    console.error("Error compressing image:", error);
                }
            }
            if (frontFile) {
                setLoading(true)
                try {
                    let obj = {
                        base64_image: frontFile,
                        doc_type: docType,
                        file_type: fileExtensiontype,
                        request_id: refId
                    }
                     console.log('handleVerify front obj:', obj);
                    // Encrypt
                    const encrypted = CryptoService.encrypt(obj);
                    // console.log("encrypted", encrypted);

                    const formdata = new FormData();
                    formdata.append("source_id", "1");
                    formdata.append("data", encrypted);

                    const requestOptions = {
                        method: "POST",
                        body: formdata,
                        redirect: "follow"
                    };

                    fetch("https://z33q3r9qqd.execute-api.ap-south-1.amazonaws.com/default/new_ovd", requestOptions)
                        .then((response) => response.json())
                        .then((result) => {
                            // console.log(result);
                            // Decrypt
                            // const decrypted = CryptoService.decrypt(result.data);
                            // console.log('Decrypted:', JSON.parse(decrypted));

                            if (result.documenttype == 0) {
                                alert('Invalid document')
                                setLoading(false)
                            }
                            else if (result.documenttype == 1) {
                                setvalidDocument(true)
                                // console.log(responseData);
                                setFetchedData({
                                    Name: result["item.details.name.value"],
                                    Addhar_No: result["item.details.aadhaar.value"],
                                    dob: result["item.details.dob"],
                                    Gender: result["item.details.gender.value"],
                                    // docImageFaceVerification: result["item.details.aadhaar.masked_value"],
                                })
                                // data:image/jpeg;base64,
                                // setPreviewImage(`data:image/jpeg;base64,${result["item.details.aadhaar.masked_value"]}`)
                                setProced(true)
                                setLoading(false)
                            } else if (result.documenttype == 2) {
                                setvalidDocument(true)
                                // console.log(responseData);
                                setFetchedData({
                                    Name: result.name,
                                    Surname: result.surname,
                                    Doc_Number: result.docnumber,
                                    Country: result.country,
                                    DOB: result.dob,
                                    Gender: result.gender,
                                    Expiry: result.expirydate,
                                })

                                setProced(true)
                                setLoading(false)
                            } else if (result.documenttype == 3) {
                                setvalidDocument(true)
                                // console.log(responseData);
                                setFetchedData({
                                    Name: result.name,
                                    License_No: result.drivinglicenseno,
                                    Date_Of_Issue: result.dateofissue,
                                    Validity: result.validitynt,
                                })

                                setProced(true)
                                setLoading(false)
                            } else if (result.documenttype == 4) {
                                setvalidDocument(true)
                                // console.log(responseData);
                                setFetchedData({
                                    Name: result.name,
                                    Voter_Id: result.voterid,
                                    Parent_Name: result.guardianname,
                                    DOB: result.dob,
                                    Gender: result.gender,
                                    Address: result.Address,
                                })

                                setProced(true)
                                setLoading(false)
                            } else {
                                setAlertMessage(true)
                                const timer = setTimeout(() => {
                                    setAlertMessage(false);
                                }, 5000);
                                setLoading(false)
                                return () => clearTimeout(timer);
                            }

                        })
                        .catch((error) => console.error(error));

                } catch (error) {
                    setLoading(false);
                    console.error("Error compressing image:", error);
                }
            }

        } catch (error) {
            console.error("Error compressing image:", error);
        }
    }

    const handleProcced = () => {
        // Logic to proceed after both sides are uploaded
        setLoading(true)
        function lmbd_ovd_step_status() {
            let obj = { request_id: refId, is_document_uploaded: true, is_ipv_done: false, is_face_match_done: false }
            console.log('obj:', obj);
            UploadDoc()
            // Encrypt
            const encrypted = CryptoService.encrypt(obj);
            // console.log("encrypted", encrypted);

            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            const raw = JSON.stringify({
                "data": encrypted,
                "source_id": "1"
            });

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };

            fetch("https://z33q3r9qqd.execute-api.ap-south-1.amazonaws.com/default/step_status", requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    console.log(result);
                    // Decrypt
                    const decrypted = CryptoService.decrypt(result.data);
                    console.log('lmbd_ovd_step_status:', JSON.parse(decrypted));
                    // step_status()
                    UploadDoc()
                })
                .catch((error) => console.error(error));

        }
        lmbd_ovd_step_status()

        function UploadDoc() {
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            const raw = JSON.stringify({
                "source_id": "1",
                "reqid": refId,
                "doctype": "ADDHAAR",
                "base64": base64File,
                "filetype": "png",
                "ovdresponse": "successfully uploaded"
            });
            console.log('raw', raw);


            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };

            fetch("https://uos01m6pv3.execute-api.ap-south-1.amazonaws.com/default/lmbd_ovd_document_upload", requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    console.log(result)
                    setFlowDoc('VedioRecorder')
                    // step_status()
                    setLoading(false)
                })
                .catch((error) => {
                    console.error(error)
                    setLoading(false)
                });
        }
    }

    return (
        <div >
            {/* <h3>Aadhaar Upload (Front & Back)</h3> */}
            <div>
                <div style={{ display: 'flex', gap: '20px', justifyContent: 'space-evenly' }}>
                    {/* FRONT Upload */}
                    <div>
                        {/* <label><strong>Front Side:</strong></label> */}
                        <div
                            onClick={() => !frontPreview && frontInputRef.current.click()}
                            style={{
                                ...uploadBoxStyle,
                                position: 'relative',
                                backgroundColor: frontPreview ? '#fff' : '#f9f9f9'
                            }}
                        >
                            {frontPreview ? (
                                frontFile?.type === 'application/pdf' ? (
                                    <embed src={frontPreview} type="application/pdf" width="100%" height="200px" />
                                ) : (
                                    <img src={frontPreview} alt="Front Preview" style={{ width: '100%', height: '100px' }} />
                                )
                            ) : (
                                <>
                                    <img
                                        src={upload}
                                        alt="Upload Icon"
                                        style={{ width: "40px", marginBottom: "1px" }}
                                    />
                                    <p style={{ marginTop: '8px' }}>Click to upload front</p>
                                </>
                            )}
                            {frontPreview && (
                                <FaTimesCircle
                                    size={20}
                                    color="red"
                                    style={removeIconStyle}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleRemove('front');
                                    }}
                                />
                            )}
                        </div>
                        <input
                            ref={frontInputRef}
                            type="file"
                            accept=".jpg,.jpeg,.png,.pdf"
                            style={{ display: 'none' }}
                            onChange={(e) => handleFileChange(e, 'front')}
                        />
                    </div>
                    {/* BACK Upload */}
                    <div>
                        {/* <label><strong>Back Side:</strong></label> */}
                        <div
                            onClick={() => !backPreview && backInputRef.current.click()}
                            style={{
                                ...uploadBoxStyle,
                                position: 'relative',
                                backgroundColor: backPreview ? '#fff' : '#f9f9f9'
                            }}
                        >
                            {backPreview ? (
                                backFile?.type === 'application/pdf' ? (
                                    <embed src={backPreview} type="application/pdf" width="100%" height="200px" />
                                ) : (
                                    <img src={backPreview} alt="Back Preview" style={{ width: '100%', height: "100px" }} />
                                )
                            ) : (
                                <>
                                    <img
                                        src={upload}
                                        alt="Upload Icon"
                                        style={{ width: "40px", marginBottom: "1px" }}
                                    />
                                    <p style={{ marginTop: '8px' }}>Click to upload back</p>
                                </>
                            )}
                            {backPreview && (
                                <FaTimesCircle
                                    size={20}
                                    color="red"
                                    style={removeIconStyle}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleRemove('back');
                                    }}
                                />
                            )}
                        </div>
                        <input
                            ref={backInputRef}
                            type="file"
                            accept=".jpg,.jpeg,.png,.pdf"
                            style={{ display: 'none' }}
                            onChange={(e) => handleFileChange(e, 'back')}
                        />
                    </div>
                </div>

                {Object.keys(fetchedData).length == 0 ?
                    <>
                        {
                            loading ? <><ShimmerTitle line={5} gap={10} variant="secondary" /></> : <>  <p style={{ fontSize: '12px', fontWeight: '600', color: '#333', margin: '20px 0', textAlign: 'center' }}>Upload any of the listed documents for OVD</p>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr ', gap: '10px', textAlign: 'left', fontSize: '12px', color: '#333' }}>
                                    <div style={{ display: 'flex' }}>  <img src={aadhaar} alt="Aadhaar Card" style={{ width: '40px', marginBottom: '10px', marginLeft: '10px', marginRight: '10px' }} /><p> Aadhaar Card</p></div>
                                    <div style={{ display: 'flex' }}>  <img src={license} alt="Driving License" style={{ width: '40px', marginBottom: '10px', marginLeft: '10px', marginRight: '10px' }} /><p>  Driving License</p></div>
                                    <div style={{ display: 'flex' }}>  <img src={passport} alt="Upload Icon" style={{ width: '40px', marginBottom: '10px', marginLeft: '10px', marginRight: '10px' }} /><p>Passport</p></div>
                                    <div style={{ display: 'flex' }}>  <img src={MGNREGA} alt="Upload Icon" style={{ width: '40px', marginBottom: '10px', marginLeft: '10px', marginRight: '10px' }} /><p>MGNREGA</p></div>
                                    <div style={{ display: 'flex' }}>  <img src={voterId} alt="Upload Icon" style={{ width: '40px', marginBottom: '10px', marginLeft: '10px', marginRight: '10px' }} /><p>Voter ID</p></div>
                                </div></>}
                    </>
                    :
                    <>
                        {
                            Object.keys(fetchedData).length > 0 && (
                                <div style={{ marginTop: '20px', fontSize: '14px', color: '#333' }}>
                                    {Object.entries(fetchedData).map(([key, value]) => (
                                        <p key={key} style={{ textAlign: 'left' }}>
                                            <strong>{key.replace(/_/g, ' ')}:</strong> {value ? value : 'N/A'}
                                        </p>
                                    ))}
                                </div>
                            )}
                    </>
                }
            </div>
            <div style={{ marginTop: '1rem' }}>
                {
                    proced ?
                        <button style={{ width: '80%', height: '40px', marginTop: '10px', padding: '8px', background: 'rgb(174, 1, 1)', border: 'none', borderRadius: '4px', color: 'white', fontSize: '16px', fontWeight: '600', cursor: "pointer", position: 'absolute', bottom: 2, transform: "translate(-50%)", left: "50%" }}
                            onClick={handleProcced}
                        >
                            {
                                loading ? <img style={{ width: '70px', marginTop: '-1.4rem' }} src={LoaderShemer} alt="My GIF" /> : ' Proceed'
                            }
                        </button> :
                        <button style={{ width: '80%', height: '40px', marginTop: '10px', padding: '8px', background: 'rgb(174, 1, 1)', border: 'none', borderRadius: '4px', color: 'white', fontSize: '16px', fontWeight: '600', cursor: "pointer", position: 'absolute', bottom: 2, transform: "translate(-50%)", left: "50%" }} onClick={handleVerify} disabled={loading} >
                            {
                                loading ? <img style={{ width: '70px', marginTop: '-1.4rem' }} src={LoaderShemer} alt="My GIF" /> : 'Verify'
                            }
                        </button>
                }
            </div>
        </div>
    );
};

// Styles
const uploadBoxStyle = {
    border: '1px solid #888',
    padding: '2px',
    cursor: 'pointer',
    textAlign: 'center',
    width: '100px',
    height: '100px',
    marginTop: '10px',
    borderRadius: '10px',
};

const removeIconStyle = {
    position: 'absolute',
    top: '10px',
    right: '10px',
    cursor: 'pointer',
    backgroundColor: '#fff',
    borderRadius: '50%',
};